import { Link, useParams, useNavigate } from "react-router-dom";
import Banner from "../../Components/Banner";
import useSWR from "swr";
import { URLS } from "../../Services/urls";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Section from "../../Components/Section";
import ProductWrapper from "../../Components/Product/ProductWrapper";
import Input from "../../Components/Input";
import StepTitle from "../../Components/Title";
import { FaLongArrowAltRight } from "react-icons/fa";
import { FaLongArrowAltLeft } from "react-icons/fa"; 
import SectionImage from "../../Components/SectionImage";
import ChoiceItem from "../../Components/ChoiceItem";
import { setSectionNames } from "../../Redux/Slice/selectedProductsSlice";

const NestedSection = () => {
  const { projectId, nestedSectionId } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { data: project, isLoading } = useSWR(URLS.PROJECT.details(projectId));
  
  // Récupérer les données Redux
  const selectedProducts = useSelector(state => state.selectedProducts.selectedProducts);
  const userInputs = useSelector(state => state.selectedProducts.userInputs);
  const sectionNames = useSelector(state => state.selectedProducts.sectionNames);
  
  const [nestedSection, setNestedSection] = useState(null);
  const [sections, setSections] = useState([]);
  const [parentSectionName, setParentSectionName] = useState('');

  // Trouver la nested_section et récupérer les sections associées
  useEffect(() => {
    if (project && nestedSectionId) {
      console.log('🔍 Recherche de la nested_section:', nestedSectionId);
      
      // Parcourir toutes les sections de toutes les étapes pour trouver la nested_section
      let foundNestedSection = null;
      let foundParentSection = null;
      
      if (project.steps) {
        for (const step of project.steps) {
          if (step.sections) {
            for (const section of step.sections) {
              if (section.nested_sections) {
                for (const nested of section.nested_sections) {
                  if (nested.id === nestedSectionId) {
                    foundNestedSection = nested;
                    foundParentSection = section;
                    break;
                  }
                }
              }
              if (foundNestedSection) break;
            }
          }
          if (foundNestedSection) break;
        }
      }
      
      if (foundNestedSection) {
        console.log('✅ Nested section trouvée:', foundNestedSection);
        setNestedSection(foundNestedSection);
        setParentSectionName(foundParentSection?.name || '');
        
        // Récupérer les sections complètes à partir des UUIDs
        const sectionIds = foundNestedSection.sections || [];
        console.log('🔍 IDs de sections à récupérer:', sectionIds);
        
        // Parcourir toutes les sections du projet pour trouver celles correspondantes
        const foundSections = [];
        if (project.steps) {
          for (const step of project.steps) {
            if (step.sections) {
              for (const section of step.sections) {
                if (sectionIds.includes(section.id)) {
                  foundSections.push(section);
                }
              }
            }
          }
        }
        
        // Trier par order si disponible
        foundSections.sort((a, b) => (a.order || 0) - (b.order || 0));
        
        console.log('✅ Sections trouvées:', foundSections);
        setSections(foundSections);
        
        // Sauvegarder les noms de sections
        const newSectionNames = { ...sectionNames };
        foundSections.forEach(section => {
          newSectionNames[section.id] = section.name;
        });
        dispatch(setSectionNames(newSectionNames));
      } else {
        console.error('❌ Nested section non trouvée:', nestedSectionId);
      }
    }
  }, [project, nestedSectionId, dispatch, sectionNames]);

  const toUpper = (sectionName) => {
    return sectionName.toUpperCase();
  };

  const handleBack = () => {
    navigate(`/projet/${projectId}`);
  };

  if (isLoading) {
    return (
      <div className="text-center py-5">
        <p>Chargement...</p>
      </div>
    );
  }

  if (!nestedSection) {
    return (
      <div className="text-center py-5">
        <p>Section imbriquée non trouvée</p>
        <Link to={`/projet/${projectId}`} className="btn btn-secondary">
          Retour au projet
        </Link>
      </div>
    );
  }

  return (
    <>
      <div>
        {isLoading && <p className="text-center">Chargement...</p>}
      </div> 
      <Banner projectName={String(project?.name).replace('_', ' ')} />
      <section className="page-banner">
        <div className="container">
          <div className="d-flex">
            <div className="m-auto">
              <div className="breadcrumbss">
                <Link to={`/projet/${projectId}`}>
                  <div className="breadcrumb-item passed">{parentSectionName || 'Projet'}</div>
                </Link>
                <div className="breadcrumb-item active">{nestedSection.name}</div>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      {/* List sections */}
      <section className="container">
        <div className="steps-list d-block">
          <StepTitle title={nestedSection.description || nestedSection.name} />
          
          {sections.map((section) => {
            console.log('🔍 Section:', section.name, 'Type:', section.section_type);
            return (
              <Section
                key={section.id}
                name={toUpper(section.name)}
                description={section.description}
                classe={section?.nested_sections?.length > 0 ? 'px-5' : section?.name === 'Taille de votre terrasse' ? 'px-5' : ''}
                textClass={section?.nested_sections?.length > 0 ? 'text' : section?.name === 'Taille de votre terrasse' ? 'text' : 'text-2'}
                sectionClass={section.name && 'bois-de-pays'}
                content={
                  <>
                    {
                      section?.choice_items?.length > 0 && (
                        section.choice_items.map(choice => (
                          <ChoiceItem
                            key={choice.id}
                            choice={choice}
                            sectionId={section.id}
                          />
                        ))
                      )
                    }

                    {
                      section?.products?.length > 0 && (
                        section?.products?.map((product) => (
                          <ProductWrapper
                            key={product.id}
                            productId={product.product}
                            productType={product.product_type}
                            section={section.id}
                            contentProductId={product.id}
                          />
                        ))
                      )
                    }

                    {
                      section?.inputs && Array.isArray(section.inputs) && section.inputs.length > 0 && (
                        section.inputs.map((input) => (
                          <Input
                            key={input.id}
                            label={input.input_label}
                            info={input.input_info}
                            description={input.description}
                            unity={input.input_unity}
                            type={input.input_type}
                            section={section.id}
                            inputKey={input.input_label || 'input'}
                          />
                        ))
                      )
                    }

                    {
                      section?.images?.length > 0 && (
                        section?.images?.map((image) => (
                          <SectionImage
                            key={image.id}
                            src={image.file}
                          />
                        ))
                      )
                    }
                  </>
                }
              />
            );
          })}
        </div>
      </section>
      
      <div className="m-auto">
        <div className="d-flex justify-content-center mb-5">
          <div className="bois-de-pays px-3 me-2">
            <span className="text-2 span">
              <Link to="#" className='d-flex align-items-center' onClick={handleBack}>
                <FaLongArrowAltLeft className='me-2' /> RETOUR
              </Link>
            </span>
          </div>
          {nestedSection.is_next && (
            <div className="btn btn-secondary px-3 rounded-0 d-flex align-items-center">
              <span className="text-2">
                <Link to={`/projet/${projectId}`} className="d-flex align-items-center">
                  SUIVANT <FaLongArrowAltRight className='ms-2'/>
                </Link>
              </span>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default NestedSection;

